


// // import React, { useState } from 'react';
// // import {
// //   UserCircleIcon,
// //   DocumentArrowUpIcon,
// //   ClipboardDocumentCheckIcon,
// //   CheckCircleIcon,
// //   ExclamationCircleIcon,
// // } from '@heroicons/react/24/solid';

// // import Step1SchoolInfo from '../components/Step1SchoolInfo';
// // import Step2UploadDocs from '../components/Step2UploadDocs';
// // import Step3ReviewSubmit from '../components/Step3ReviewSubmit';
// // import { useNavigate } from 'react-router-dom';
// // import toast from 'react-hot-toast';

// // const stepsConfig = [
// //   { id: 1, label: 'School Info', icon: UserCircleIcon },
// //   { id: 2, label: 'Upload Documents', icon: DocumentArrowUpIcon },
// //   { id: 3, label: 'Review & Submit', icon: ClipboardDocumentCheckIcon },
// // ];

// // const RegisterSchool = () => {
// //   const navigate = useNavigate();
// //   const [step, setStep] = useState(1);
// //   const [completedSteps, setCompletedSteps] = useState([]);

// //   const [schoolInfo, setSchoolInfo] = useState({
// //     name: '',
// //     description: '',
// //     establishedYear: '',
// //     boardAffiliation: '',
// //     medium: '',
// //     country: 'India',
// //     state: '',
// //     city: '',
// //     fullAddress: '',
// //     pincode: '',
// //     landmark: '',
// //     email: '',
// //     contactEmail: '',
// //     phone: '',
// //     subscriptionType: '',
// //   });

// //   const [documents, setDocuments] = useState({
// //     logo: null,
// //     banner: [],
// //     registrationCert: null,
// //     affiliationLetter: null,
// //     principalID: null,
// //     panCard: null,
// //   });

// //   const nextStep = () => {
// //     if (!completedSteps.includes(step)) {
// //       setCompletedSteps((prev) => [...prev, step]);
// //     }
// //     setStep((prev) => Math.min(prev + 1, stepsConfig.length));
// //   };

// //   const prevStep = () => {
// //     setStep((prev) => Math.max(prev - 1, 1));
// //   };

// //   const goToStep = (targetStep) => {
// //     if (targetStep < step) {
// //       setStep(targetStep);
// //       return;
// //     }

// //     const allPreviousCompleted = stepsConfig
// //       .filter(({ id }) => id < targetStep)
// //       .every(({ id }) => completedSteps.includes(id));

// //     if (allPreviousCompleted) {
// //       setStep(targetStep);
// //     } else {
// //       toast.error('Please complete previous steps before continuing.');
// //     }
// //   };

// //   const validateAll = () => {
// //     // Required fields for school info
// //     const requiredFields = [
// //       'name', 'description', 'establishedYear', 'boardAffiliation',
// //       'medium', 'country', 'state', 'city', 'fullAddress',
// //       'pincode', 'email', 'contactEmail', 'phone'
// //     ];

// //     for (const field of requiredFields) {
// //       if (!schoolInfo[field] || schoolInfo[field].trim() === '') {
// //         toast.error(`Please complete the School Info: ${field}`);
// //         setStep(1);
// //         return false;
// //       }
// //     }

// //     if (!/^\d{6}$/.test(schoolInfo.pincode)) {
// //       toast.error('Pincode must be a 6-digit number');
// //       setStep(1);
// //       return false;
// //     }

// //     const currentYear = new Date().getFullYear();
// //     const year = parseInt(schoolInfo.establishedYear, 10);
// //     if (isNaN(year) || year < 1800 || year > currentYear) {
// //       toast.error(`Year of Establishment must be valid (1800 - ${currentYear})`);
// //       setStep(1);
// //       return false;
// //     }

// //     // Required documents
// //     const requiredDocs = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];
// //     for (const doc of requiredDocs) {
// //       if (!documents[doc] || (Array.isArray(documents[doc]) && documents[doc].length === 0)) {
// //         toast.error(`Missing document: ${doc}`);
// //         setStep(2);
// //         return false;
// //       }
// //     }

// //     return true;
// //   };

// //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// //   const handleSubmit = async () => {
// //     if (!validateAll()) return;
  
// //     const formData = new FormData();
  
// //     // Append school info
// //     for (const key in schoolInfo) {
// //       if (schoolInfo[key]) {
// //         formData.append(key, schoolInfo[key]);
// //       }
// //     }
  
// //     // Append documents
// //     formData.append('logo', documents.logo);
// //     formData.append('registrationCert', documents.registrationCert);
// //     formData.append('affiliationLetter', documents.affiliationLetter);
// //     formData.append('principalID', documents.principalID);
// //     formData.append('panCard', documents.panCard);
  
// //     // Append banner files (can be multiple)
// //     if (Array.isArray(documents.banner)) {
// //       documents.banner.forEach((file, index) => {
// //         formData.append('banner', file); // backend should handle multiple 'banner' fields
// //       });
// //     }
  
// //     try {
// //       const response = await fetch(`${BACKEND_URL}/api/v1/registerSchool`, {
// //         method: 'POST',
// //         body: formData,
// //       });
  
// //       const result = await response.json();
  
// //       if (!response.ok) {
// //         toast.error(result.error || 'Registration failed');
// //         return;
// //       }

// //       if (!completedSteps.includes(3)) {
// //         setCompletedSteps(prev => [...prev, 3]);
// //       }
  
// //       toast.success(result.message || 'School registered successfully!');
// //       // setTimeout(() => navigate('/'), 1500);
// //     } catch (error) {
// //       console.error('Submit error:', error);
// //       toast.error('Something went wrong. Please try again.');
// //     }
// //   };
  

// //   const renderStep = () => {
// //     switch (step) {
// //       case 1:
// //         return <Step1SchoolInfo data={schoolInfo} setData={setSchoolInfo} onNext={nextStep} />;
// //       case 2:
// //         return <Step2UploadDocs data={documents} setData={setDocuments} onNext={nextStep} onBack={prevStep} />;
// //       case 3:
// //         return <Step3ReviewSubmit schoolInfo={schoolInfo} documents={documents} onBack={prevStep} onSubmit={handleSubmit} />;
// //       default:
// //         return null;
// //     }
// //   };

// //   return (
// //     <div className="bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] min-h-screen px-4 py-10 flex justify-center">
// //       <div className="w-full max-w-4xl bg-[#1e293b] border border-slate-700 p-6 rounded-xl shadow-2xl text-white">

// //         {/* Title */}
// //         <h1 className="text-3xl font-extrabold text-center mb-8 flex items-center justify-center gap-2">
// //           <ClipboardDocumentCheckIcon className="w-8 h-8 text-indigo-400" />
// //           School Registration
// //         </h1>

// //         {/* Instructions */}
// //         <section className="bg-slate-800 rounded p-5 mb-10 text-sm leading-relaxed border border-slate-600">
// //           <div className="flex gap-2 items-start mb-3">
// //             <ExclamationCircleIcon className="w-5 h-5 text-yellow-400 mt-[2px]" />
// //             <h2 className="text-base font-semibold">Please read before proceeding:</h2>
// //           </div>
// //           <ul className="list-disc list-inside space-y-1 text-gray-300 ml-2">
// //             <li>All fields marked with <span className="text-red-400">*</span> are mandatory.</li>
// //             <li>Prepare the following documents:
// //               <ul className="ml-5 list-disc">
// //                 <li>School Logo (JPG/PNG)</li>
// //                 <li>Banner Image (JPG/PNG, max 5)</li>
// //                 <li>Registration Certificate (PDF)</li>
// //                 <li>Affiliation Letter (PDF)</li>
// //                 <li>Principal’s ID Proof (PDF or Image)</li>
// //                 <li>PAN Card (PDF or Image)</li>
// //               </ul>
// //             </li>
           
// //             <li>Final submission requires all details and documents.</li>
// //           </ul>
// //         </section>

// //         {/* Stepper */}
// //         <div className="mb-10 overflow-x-auto">
// //           <div className="flex items-center min-w-[600px] px-2">
// //             {stepsConfig.map(({ id, label, icon: Icon }, index) => {
// //               const isCompleted = completedSteps.includes(id);
// //               const isActive = step === id;

// //               return (
// //                 <React.Fragment key={id}>
// //                   <div
// //                     onClick={() => goToStep(id)}
// //                     className="flex flex-col items-center cursor-pointer group relative z-10"
// //                   >
// //                     <div
// //                       className={`w-10 h-10 rounded-full border-2 flex items-center justify-center text-white transition-all
// //                       ${isCompleted ? 'bg-emerald-500 border-emerald-500'
// //                         : isActive ? 'bg-indigo-600 border-indigo-600'
// //                           : 'bg-slate-700 border-slate-500 group-hover:border-indigo-400'}`}
// //                     >
// //                       {isCompleted ? <CheckCircleIcon className="w-6 h-6" /> : <Icon className="w-6 h-6" />}
// //                     </div>
// //                     <p className={`mt-2 text-xs text-center whitespace-nowrap
// //                       ${isActive ? 'text-white font-medium' : 'text-gray-400 group-hover:text-indigo-400'}`}>
// //                       {label}
// //                     </p>
// //                   </div>

// //                   {index < stepsConfig.length - 1 && (
// //                     <div className="flex-1 h-1 bg-slate-600 relative top-[-10px] mx-2 rounded-full group-hover:bg-indigo-500 transition-all"></div>
// //                   )}
// //                 </React.Fragment>
// //               );
// //             })}
// //           </div>
// //         </div>

// //         {/* Step Content */}
// //         {renderStep()}
// //       </div>
// //     </div>
// //   );
// // };

// // export default RegisterSchool;

// import React, { useState } from 'react';
// import {
//   UserCircleIcon,
//   DocumentArrowUpIcon,
//   ClipboardDocumentCheckIcon,
//   CheckCircleIcon,
//   ExclamationCircleIcon,
// } from '@heroicons/react/24/solid';

// import Step1SchoolInfo from '../components/Step1SchoolInfo';
// import Step2UploadDocs from '../components/Step2UploadDocs';
// import Step3ReviewSubmit from '../components/Step3ReviewSubmit';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';

// const stepsConfig = [
//   { id: 1, label: 'School Info', icon: UserCircleIcon },
//   { id: 2, label: 'Upload Documents', icon: DocumentArrowUpIcon },
//   { id: 3, label: 'Review & Submit', icon: ClipboardDocumentCheckIcon },
// ];

// const RegisterSchool = () => {
//   const navigate = useNavigate();
//   const [step, setStep] = useState(1);
//   const [completedSteps, setCompletedSteps] = useState([]);

//   const [schoolInfo, setSchoolInfo] = useState({
//     name: '',
//     description: '',
//     establishedYear: '',
//     boardAffiliation: '',
//     medium: '',
//     country: 'India',
//     state: '',
//     city: '',
//     fullAddress: '',
//     pincode: '',
//     landmark: '',
//     email: '',
//     contactEmail: '',
//     phone: '',
//     subscriptionType: '',
//   });

//   const [documents, setDocuments] = useState({
//     logo: null,
//     banner: [],
//     registrationCert: null,
//     affiliationLetter: null,
//     principalID: null,
//     panCard: null,
//   });

//   const nextStep = () => {
//     if (!completedSteps.includes(step)) {
//       setCompletedSteps((prev) => [...prev, step]);
//     }
//     setStep((prev) => Math.min(prev + 1, stepsConfig.length));
//   };

//   const prevStep = () => {
//     setStep((prev) => Math.max(prev - 1, 1));
//   };

//   const goToStep = (targetStep) => {
//     if (targetStep < step) {
//       setStep(targetStep);
//       return;
//     }

//     const allPreviousCompleted = stepsConfig
//       .filter(({ id }) => id < targetStep)
//       .every(({ id }) => completedSteps.includes(id));

//     if (allPreviousCompleted) {
//       setStep(targetStep);
//     } else {
//       toast.error('Please complete previous steps before continuing.');
//     }
//   };

//   const validateAll = () => {
//     const requiredFields = [
//       'name', 'description', 'establishedYear', 'boardAffiliation',
//       'medium', 'country', 'state', 'city', 'fullAddress',
//       'pincode', 'email', 'contactEmail', 'phone'
//     ];

//     for (const field of requiredFields) {
//       if (!schoolInfo[field] || schoolInfo[field].trim() === '') {
//         toast.error(`Please complete the School Info: ${field}`);
//         setStep(1);
//         return false;
//       }
//     }

//     if (!/^\d{6}$/.test(schoolInfo.pincode)) {
//       toast.error('Pincode must be a 6-digit number');
//       setStep(1);
//       return false;
//     }

//     const currentYear = new Date().getFullYear();
//     const year = parseInt(schoolInfo.establishedYear, 10);
//     if (isNaN(year) || year < 1800 || year > currentYear) {
//       toast.error(`Year of Establishment must be valid (1800 - ${currentYear})`);
//       setStep(1);
//       return false;
//     }

//     const requiredDocs = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];
//     for (const doc of requiredDocs) {
//       if (!documents[doc] || (Array.isArray(documents[doc]) && documents[doc].length === 0)) {
//         toast.error(`Missing document: ${doc}`);
//         setStep(2);
//         return false;
//       }
//     }

//     return true;
//   };

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

//   const handleSubmit = async () => {
//     if (!validateAll()) return;

//     const formData = new FormData();

//     for (const key in schoolInfo) {
//       if (schoolInfo[key]) {
//         formData.append(key, schoolInfo[key]);
//       }
//     }

//     formData.append('logo', documents.logo);
//     formData.append('registrationCert', documents.registrationCert);
//     formData.append('affiliationLetter', documents.affiliationLetter);
//     formData.append('principalID', documents.principalID);
//     formData.append('panCard', documents.panCard);

//     if (Array.isArray(documents.banner)) {
//       documents.banner.forEach((file) => {
//         formData.append('banner', file);
//       });
//     }

//     try {
//       const response = await fetch(`${BACKEND_URL}/api/v1/registerSchool`, {
//         method: 'POST',
//         body: formData,
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         toast.error(result.error || 'Registration failed');
//         return;
//       }

//       if (!completedSteps.includes(3)) {
//         setCompletedSteps(prev => [...prev, 3]);
//       }

//       toast.success(result.message || 'School registered successfully!');
//       // setTimeout(() => navigate('/'), 1500);
//     } catch (error) {
//       console.error('Submit error:', error);
//       toast.error('Something went wrong. Please try again.');
//     }
//   };

//   const renderStep = () => {
//     switch (step) {
//       case 1:
//         return <Step1SchoolInfo data={schoolInfo} setData={setSchoolInfo} onNext={nextStep} />;
//       case 2:
//         return <Step2UploadDocs data={documents} setData={setDocuments} onNext={nextStep} onBack={prevStep} />;
//       case 3:
//         return <Step3ReviewSubmit schoolInfo={schoolInfo} documents={documents} onBack={prevStep} onSubmit={handleSubmit} />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="bg-gradient-to-b from-[#EAF1FB] to-white min-h-screen px-4 py-12 flex justify-center">
//       <div className="w-full max-w-4xl bg-white border border-[#E3E8F0] p-6 md:p-8 rounded-2xl shadow-[0_20px_45px_-24px_rgba(22,56,99,0.25)]">

//         {/* Title */}
//         <h1 className="font-['Fraunces',serif] text-2xl md:text-3xl text-center mb-8 flex items-center justify-center gap-2 text-[#101826]">
//           <ClipboardDocumentCheckIcon className="w-7 h-7 text-[#2E63B8]" />
//           School Registration
//         </h1>

//         {/* Instructions */}
//         <section className="bg-[#F4F8FC] rounded-xl p-5 mb-10 text-sm leading-relaxed border border-[#E3E8F0]">
//           <div className="flex gap-2 items-start mb-3">
//             <ExclamationCircleIcon className="w-5 h-5 text-[#E8A63C] mt-[2px]" />
//             <h2 className="font-['Sora',sans-serif] text-base font-semibold text-[#101826]">Please read before proceeding</h2>
//           </div>
//           <ul className="list-disc list-inside space-y-1 text-[#5A6478] font-['Sora',sans-serif] ml-2">
//             <li>All fields marked with <span className="text-red-500">*</span> are mandatory.</li>
//             <li>Prepare the following documents:
//               <ul className="ml-5 list-disc">
//                 <li>School logo (JPG/PNG)</li>
//                 <li>Banner image (JPG/PNG, max 5)</li>
//                 <li>Registration certificate (PDF)</li>
//                 <li>Affiliation letter (PDF)</li>
//                 <li>Principal's ID proof (PDF or image)</li>
//                 <li>PAN card (PDF or image)</li>
//               </ul>
//             </li>
//             <li>Final submission requires all details and documents.</li>
//           </ul>
//         </section>

//         {/* Stepper */}
//         <div className="mb-10 overflow-x-auto">
//           <div className="flex items-center min-w-[600px] px-2">
//             {stepsConfig.map(({ id, label, icon: Icon }, index) => {
//               const isCompleted = completedSteps.includes(id);
//               const isActive = step === id;

//               return (
//                 <React.Fragment key={id}>
//                   <div
//                     onClick={() => goToStep(id)}
//                     className="flex flex-col items-center cursor-pointer group relative z-10"
//                   >
//                     <div
//                       className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all
//                       ${isCompleted ? 'bg-[#E8A63C] border-[#E8A63C] text-white'
//                         : isActive ? 'bg-[#163863] border-[#163863] text-white'
//                           : 'bg-white border-[#D8DEE9] text-[#8891A0] group-hover:border-[#2E63B8]'}`}
//                     >
//                       {isCompleted ? <CheckCircleIcon className="w-6 h-6" /> : <Icon className="w-6 h-6" />}
//                     </div>
//                     <p className={`mt-2 text-xs text-center whitespace-nowrap font-['Sora',sans-serif]
//                       ${isActive ? 'text-[#101826] font-semibold' : 'text-[#8891A0] group-hover:text-[#2E63B8]'}`}>
//                       {label}
//                     </p>
//                   </div>

//                   {index < stepsConfig.length - 1 && (
//                     <div className="flex-1 h-1 bg-[#E3E8F0] relative top-[-10px] mx-2 rounded-full"></div>
//                   )}
//                 </React.Fragment>
//               );
//             })}
//           </div>
//         </div>

//         {/* Step Content */}
//         {renderStep()}
//       </div>
//     </div>
//   );
// };

// export default RegisterSchool;


import React, { useState } from 'react';
import {
  UserCircleIcon,
  DocumentArrowUpIcon,
  ClipboardDocumentCheckIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/24/solid';

import Step1SchoolInfo from '../components/Step1SchoolInfo';
import Step2UploadDocs from '../components/Step2UploadDocs';
import Step3ReviewSubmit from '../components/Step3ReviewSubmit';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const bodyFont = { fontFamily: "'Sora', sans-serif" };
const displayFont = { fontFamily: "'Fraunces', serif" };

const stepsConfig = [
  { id: 1, label: 'School Info', icon: UserCircleIcon },
  { id: 2, label: 'Upload Documents', icon: DocumentArrowUpIcon },
  { id: 3, label: 'Review & Submit', icon: ClipboardDocumentCheckIcon },
];

const RegisterSchool = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);

  const [schoolInfo, setSchoolInfo] = useState({
    name: '',
    description: '',
    establishedYear: '',
    boardAffiliation: '',
    medium: '',
    country: 'India',
    state: '',
    city: '',
    fullAddress: '',
    pincode: '',
    landmark: '',
    email: '',
    contactEmail: '',
    phone: '',
    subscriptionType: '',
  });

  const [documents, setDocuments] = useState({
    logo: null,
    banner: [],
    registrationCert: null,
    affiliationLetter: null,
    principalID: null,
    panCard: null,
  });

  const nextStep = () => {
    if (!completedSteps.includes(step)) {
      setCompletedSteps((prev) => [...prev, step]);
    }
    setStep((prev) => Math.min(prev + 1, stepsConfig.length));
  };

  const prevStep = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };

  const goToStep = (targetStep) => {
    if (targetStep < step) {
      setStep(targetStep);
      return;
    }

    const allPreviousCompleted = stepsConfig
      .filter(({ id }) => id < targetStep)
      .every(({ id }) => completedSteps.includes(id));

    if (allPreviousCompleted) {
      setStep(targetStep);
    } else {
      toast.error('Please complete previous steps before continuing.');
    }
  };

  const validateAll = () => {
    const requiredFields = [
      'name', 'description', 'establishedYear', 'boardAffiliation',
      'medium', 'country', 'state', 'city', 'fullAddress',
      'pincode', 'email', 'contactEmail', 'phone'
    ];

    for (const field of requiredFields) {
      if (!schoolInfo[field] || schoolInfo[field].trim() === '') {
        toast.error(`Please complete the School Info: ${field}`);
        setStep(1);
        return false;
      }
    }

    if (!/^\d{6}$/.test(schoolInfo.pincode)) {
      toast.error('Pincode must be a 6-digit number');
      setStep(1);
      return false;
    }

    const currentYear = new Date().getFullYear();
    const year = parseInt(schoolInfo.establishedYear, 10);
    if (isNaN(year) || year < 1800 || year > currentYear) {
      toast.error(`Year of Establishment must be valid (1800 - ${currentYear})`);
      setStep(1);
      return false;
    }

    const requiredDocs = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];
    for (const doc of requiredDocs) {
      if (!documents[doc] || (Array.isArray(documents[doc]) && documents[doc].length === 0)) {
        toast.error(`Missing document: ${doc}`);
        setStep(2);
        return false;
      }
    }

    return true;
  };

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const handleSubmit = async () => {
    if (!validateAll()) return;

    const formData = new FormData();

    for (const key in schoolInfo) {
      if (schoolInfo[key]) {
        formData.append(key, schoolInfo[key]);
      }
    }

    formData.append('logo', documents.logo);
    formData.append('registrationCert', documents.registrationCert);
    formData.append('affiliationLetter', documents.affiliationLetter);
    formData.append('principalID', documents.principalID);
    formData.append('panCard', documents.panCard);

    if (Array.isArray(documents.banner)) {
      documents.banner.forEach((file) => {
        formData.append('banner', file);
      });
    }

    let response;
    try {
      response = await fetch(`${BACKEND_URL}/api/v1/registerSchool`, {
        method: 'POST',
        body: formData,
      });
    } catch (networkError) {
      console.error('Network error during registration:', networkError);
      const message = 'Could not reach the server. Please check your connection and try again.';
      toast.error(message);
      throw new Error(message);
    }

    let result;
    try {
      result = await response.json();
    } catch (parseError) {
      console.error('Invalid server response:', parseError);
      const message = 'Unexpected response from the server. Please try again.';
      toast.error(message);
      throw new Error(message);
    }

    if (!response.ok) {
      // e.g. duplicate email, missing required field/document — the server's
      // specific reason lives in result.error
      const message = result.error || result.message || 'Registration failed. Please review your details and try again.';
      toast.error(message);
      throw new Error(message); // <-- Step3ReviewSubmit relies on this throw
    }

    if (!completedSteps.includes(3)) {
      setCompletedSteps((prev) => [...prev, 3]);
    }

    toast.success(result.message || 'School registered successfully!');
    return result; // handed to Step3ReviewSubmit → SuccessMessage
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1SchoolInfo data={schoolInfo} setData={setSchoolInfo} onNext={nextStep} />;
      case 2:
        return <Step2UploadDocs data={documents} setData={setDocuments} onNext={nextStep} onBack={prevStep} />;
      case 3:
        return <Step3ReviewSubmit schoolInfo={schoolInfo} documents={documents} onBack={prevStep} onSubmit={handleSubmit} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="min-h-screen px-4 py-12 md:py-16 flex justify-center bg-gradient-to-b from-[#EEF3FC] via-white to-[#F8FAFD]"
      style={bodyFont}
    >
      <div className="w-full max-w-4xl">
        <div className="relative bg-white border border-[#EDF1F7] rounded-3xl shadow-[0_30px_70px_-35px_rgba(22,56,99,0.4)] overflow-hidden">
          {/* Brand accent bar */}
          <div className="h-[4px] w-full bg-gradient-to-r from-[#E8A63C] via-[#2E63B8] to-[#163863]" />

          <div className="p-6 md:p-10 lg:p-12">
            {/* Title */}
            <div className="flex flex-col items-center text-center mb-9">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#163863] to-[#2E63B8] flex items-center justify-center shadow-lg shadow-[#163863]/25 mb-4">
                <ClipboardDocumentCheckIcon className="w-7 h-7 text-white" />
              </div>
              <h1 style={displayFont} className="text-2xl md:text-[2rem] text-[#101826]">
                School Registration
              </h1>
              <p className="text-[#5A6478] text-sm mt-1.5">
                Get your school live on Eduvantra in three simple steps.
              </p>
            </div>

            {/* Instructions */}
            <section className="bg-[#F6F9FD] border border-[#E7ECF3] rounded-2xl p-5 mb-10">
              <div className="flex gap-2 items-start mb-3">
                <ExclamationCircleIcon className="w-5 h-5 text-[#E8A63C] mt-[2px] shrink-0" />
                <h2 className="text-[15px] font-semibold text-[#101826]">Please read before proceeding</h2>
              </div>
              <ul className="list-disc list-inside space-y-1 text-[#5A6478] text-sm ml-1">
                <li>All fields marked with <span className="text-red-500">*</span> are mandatory.</li>
                <li>Prepare the following documents:
                  <ul className="ml-5 list-disc mt-1">
                    <li>School logo (JPG/PNG)</li>
                    <li>Banner image (JPG/PNG, max 5)</li>
                    <li>Registration certificate (PDF)</li>
                    <li>Affiliation letter (PDF)</li>
                    <li>Principal's ID proof (PDF or image)</li>
                    <li>PAN card (PDF or image)</li>
                  </ul>
                </li>
                <li>Final submission requires all details and documents.</li>
              </ul>
            </section>

            {/* Stepper */}
            <div className="mb-10 overflow-x-auto">
              <div className="flex items-center min-w-[560px] px-2">
                {stepsConfig.map(({ id, label, icon: Icon }, index) => {
                  const isCompleted = completedSteps.includes(id);
                  const isActive = step === id;

                  return (
                    <React.Fragment key={id}>
                      <div
                        onClick={() => goToStep(id)}
                        className="flex flex-col items-center cursor-pointer group relative z-10"
                      >
                        <div
                          className={`w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 ${
                            isCompleted
                              ? 'bg-gradient-to-br from-[#E8A63C] to-[#D6952E] text-white shadow-md shadow-[#E8A63C]/30'
                              : isActive
                              ? 'bg-gradient-to-br from-[#163863] to-[#2E63B8] text-white shadow-md shadow-[#163863]/30'
                              : 'bg-white border-2 border-[#E3E8F0] text-[#B7BFCC] group-hover:border-[#2E63B8]'
                          }`}
                        >
                          {isCompleted ? <CheckCircleIcon className="w-5 h-5" /> : <Icon className="w-5 h-5" />}
                        </div>
                        <p
                          className={`mt-2 text-xs text-center whitespace-nowrap ${
                            isActive ? 'text-[#101826] font-semibold' : 'text-[#8891A0] group-hover:text-[#2E63B8]'
                          }`}
                        >
                          {label}
                        </p>
                      </div>

                      {index < stepsConfig.length - 1 && (
                        <div className="flex-1 h-[3px] mx-2 rounded-full relative top-[-11px] bg-[#E7ECF3] overflow-hidden">
                          <div
                            className={`h-full bg-gradient-to-r from-[#E8A63C] to-[#2E63B8] transition-all duration-500 ${
                              isCompleted ? 'w-full' : 'w-0'
                            }`}
                          />
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>

            {/* Step Content */}
            {renderStep()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterSchool;
